if (!customElements.get('verso-slider')) {
  customElements.define('verso-slider', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.track = this.querySelector('[data-track]');
      this.slides = [...this.querySelectorAll('.mf-slide')];
      this.dots = [...this.querySelectorAll('[data-dot]')];
      this.index = 0;
      this.paused = false;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1), options);
      this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1), options);
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.dot)), options));
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        this.go(event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : this.index + (event.key === 'ArrowLeft' ? -1 : 1));
      }, options);
      this.track.addEventListener('scroll', () => this.setActive(Math.round(this.track.scrollLeft / this.track.clientWidth)), { ...options, passive: true });
      ['mouseenter', 'focusin', 'touchstart'].forEach((type) => this.addEventListener(type, () => this.stop(), options));
      ['mouseleave', 'focusout'].forEach((type) => this.addEventListener(type, () => this.start(), options));
      this.querySelector('[data-pause-button]')?.addEventListener('click', (event) => {
        this.paused = !this.paused;
        event.currentTarget.textContent = this.paused ? this.dataset.play : this.dataset.pause;
        this.start();
      }, options);
      this.setActive(0);
      this.start();
    }
    setActive(index) {
      this.index = Math.min(Math.max(index, 0), this.slides.length - 1);
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
    }
    go(index) {
      if (!this.slides.length) return;
      const next = (index + this.slides.length) % this.slides.length;
      this.track.scrollTo({ left: this.track.clientWidth * next, behavior: this.reduced ? 'auto' : 'smooth' });
      this.setActive(next);
    }
    stop() { clearInterval(this.timer); }
    start() {
      this.stop();
      if (this.dataset.autoplay !== 'true' || this.paused || this.reduced || this.matches(':focus-within') || this.slides.length < 2) return;
      this.timer = setInterval(() => this.go(this.index + 1), Number(this.dataset.interval) || 7000);
    }
    disconnectedCallback() { this.stop(); this.abort?.abort(); }
  });
}
